export const SwitchSize = {
  sm: 'sm',
  xl: 'xl',
} as const
